import {loadScript} from "../methods/script-loader.js";

const URL_RECAPTCHA_LIB = "https://www.recaptcha.net/recaptcha/enterprise.js",
    COMPONENT_REFERENCE = "Alpine reCAPTCHA";

export default (action = null) => ({

    trigger: document.getElementById("grecaptcha-trigger"),
    awaitingToken: false,

    onLoadGrecaptcha() {
        let self = this;
        // console.log(`${ COMPONENT_REFERENCE }: reCAPTCHA is loaded`, { "lib": window.grecaptcha, "this": this });
        this.$nextTick(() => {
            window.grecaptcha.enterprise.ready( self.onReadyGrecaptcha.bind( self ) );
        });
    },

    async onClickTrigger( event ) {

            event.preventDefault();
            // console.log(`${ COMPONENT_REFERENCE }: click detected`, { event, action, "trigger": this.trigger } );
            if ( this.awaitingToken ) { return; }

            this.awaitingToken = true;
            try {
                // console.log(`${ COMPONENT_REFERENCE }: attempting "window.grecaptcha.enterprise.reset()"` );
                window.grecaptcha.enterprise.reset();
                // console.log(`${ COMPONENT_REFERENCE }: sending object to "window.grecaptcha.enterprise.execute()"`, { "execute object": { action: action } } );
                const token = await window.grecaptcha.enterprise.execute({
                    action: action,
                });
                //console.log("gonna check livewire");
                //console.log(!!window.Livewire);
                if (!!window.Livewire) {
                    // console.log(`${ COMPONENT_REFERENCE }: found "window.Livewire"` );
                    // console.log(`${ COMPONENT_REFERENCE }: attempting "window.Livewire.emit( 'validate', token, action )`, { token, action } );
                    //window.Livewire.emit("validate", token, action );
                    window.Livewire.dispatch("validate", { token , action });
                }

                this.awaitingToken = false;
            } catch (error) {
                // console.log(`${ COMPONENT_REFERENCE }: Error requesting reCAPTCHA token`, { error } );
                // console.error( "Error requesting reCAPTCHA token", {error});
                // TODO: emit a "token process failure" event to Livewire
                this.awaitingToken = false;
            }



    },
    onReadyGrecaptcha() {
        // console.log(`${ COMPONENT_REFERENCE }: reCAPTCHA is ready` );
        // console.log("reCAPTCHA is ready", { "this": this });
        const configuration = {
            "sitekey": process.env.RECAPTCHA_ENTERPRISE_SCORE_KEY,
            "size": "invisible",
            "error-callback": () => {
                console.log("reCAPTCHA ERROR", {arguments});
            }
        };

        // console.log(`${ COMPONENT_REFERENCE }: attempting "window.grecaptcha.enterprise.render`, {
        //     "target DOM element": document.getElementById("grecaptcha-container"),
        //     configuration
        // } );
        window.grecaptcha.enterprise.render( document.getElementById("grecaptcha-container"), configuration );

        // console.log(`${ COMPONENT_REFERENCE }: setting "click" listener` );
        this.trigger.addEventListener("click", this.onClickTrigger );

    },


    init() {
        // console.log(`${ COMPONENT_REFERENCE }: reCAPTCHA component`, {
        //     action,
        //     "this": this,
        //     RECAPTCHA_ENTERPRISE_SCORE_KEY: process.env.RECAPTCHA_ENTERPRISE_SCORE_KEY
        // } );

        // console.log('reCAPTCHA component', {action, "this": this});
        let self = this;

        if (!window.grecaptcha) {
            // console.log(`%c${ COMPONENT_REFERENCE }: reCAPTCHA script was missing, so I'm loading: "${ URL_RECAPTCHA_LIB }?render=${ process.env.RECAPTCHA_ENTERPRISE_SCORE_KEY }"`, "color: red; font-weight: 700; font-size: 18px;" );
            loadScript( `${ URL_RECAPTCHA_LIB }?render=${ process.env.RECAPTCHA_ENTERPRISE_SCORE_KEY }`, self.onLoadGrecaptcha.bind( self ) );
        } else {
            // console.log(`${ COMPONENT_REFERENCE }: reCAPTCHA script was found, carrying on` );
            self.onLoadGrecaptcha();
        }
    }
});
